import { unstable_createMuiStrictModeTheme as createMuiTheme, } from '@material-ui/core/styles';

const colors = {
    primary: '#f58634',
    primaryLight: '#fef3ea',
    secondary: '#5d5d5d',
    yellow: 'yellow',
    green: 'green'
};

const theme = createMuiTheme({
    palette: {
      primary: {
        main: colors.primary,
        button: colors.primary,
      },
      secondary: {
        main: colors.secondary,
      },
      yellow: {
        main: colors.yellow
      },
      green: {
        main: colors.green
      }
    }
});

export default theme;